import { http, uploadFile } from '@/utils/axios'
import qs from 'qs'


/**
 * @msg: 获取小组列表
 */
export function getGroupList({ page = 0, pageSize = 10, courseId = '', infoType = '', uid = '' }) {
  return http({
    url: http.baseUrl('zkolGroup/getGroupList'),
    method: 'post',
    params: http.params({
      page,
      pageSize,
      courseId,
      infoType,
      uid
    })
  })
}

/**
 * @msg:小组详情
 */
export function ViewDetails({ page = 0, pageSize = 10, courseId, infoType }) {
  return http({
    url: http.baseUrl('notice/ViewDetails'),
    method: 'post',
    params: http.params({
      page,
      pageSize,
      courseId,
      infoType,
    })
  })
}
/**
 * @msg:编辑小组
 */
export function EditorialTeam({ page = 0, pageSize = 10, courseId, infoType }) {
  return http({
    url: http.baseUrl('notice/EditorialTeam'),
    method: 'get',
    params: http.params({
      page,
      pageSize,
      courseId,
      infoType,
    })
  })
}

/**
 * @msg:新增
 */
export function saveOrUpdate(data) {
  return http({
    url: http.baseUrl('zkolGroup/saveOrUpdate'),
    method: 'post',
    params: http.params(data)
  })
}


/**
 * @msg:删除
 */
export function deletes(data) {
  return http({
    url: http.baseUrl('zkolGroup/delete'),
    method: 'post',
    params: http.params(data)
  })
}

/**
 * @msg:获取老师分组
 */
export function getGroupUserList(data) {
  return http({
    url: http.baseUrl('zkolGroup/getGroupUserList'),
    method: 'post',
    params: http.params(data)
  })
}

/**
 * @msg:获取学生分组
 */
export function getStudentByCourseList(params) {
  console.log(JSON.stringify(params));
  console.log("1==============");
  return http({
    url: http.baseUrl('zkolGroup/getStudentByCourseList'),
    method: 'post',
    params: http.params(params)
  })
}


/**
 * @msg: 通过uid获取用户
 */
export function getUserByUid(uid) {
  return http({
    url: http.baseUrl('elUser/getUserByUid'),
    method: 'get',
    params: http.params({
      uid
    })
  })
}

/**
 * @msg: 通过uid获取机构
 */
export function getSchoolByUid(uid) {
  return http({
    url: http.baseUrl('elSchool/getSchoolByUid'),
    method: 'get',
    params: http.params({
      uid
    })
  })
}
